import React from "react";
import {
    Button, Typography,
} from "@mui/material";
import {Markdown} from "~/release-notes/components/Markdown";
import {Dialog} from "~/components/Dialog";
import {ReleaseNote} from "~/queries";


export type ReleaseNoteModalProps = {
    open: boolean
    releaseNote: ReleaseNote
    onClose?: () => void
    onShowAllClick?: () => void
}


export const ReleaseNoteModal = (props: ReleaseNoteModalProps) => {
    const {releaseNote, onClose, onShowAllClick, open} = props;

    return (
        <Dialog
            open={open}
            title={releaseNote.title}
            onClose={onClose}
            actions={
                <>
                    <Button size="small" color="additionalSecondary" onClick={onShowAllClick}>
                        Показать все
                    </Button>
                    <Button size="small" color="additionalPrimary" onClick={onClose}>
                        ОК
                    </Button>
                </>
            }
        >
            <Typography variant="cardText" color="primary">
                <Markdown>
                    {releaseNote.content}
                </Markdown>
            </Typography>
        </Dialog>
    )
}